
<template>
  <div id="accordionExamplehealth" class="accordion p-2 border-rounded bg-white" style="border-radius: 15px;">
    <div style="padding: 10px; background-color: rgb(55 71 195 / 59%); border-radius: 15px; margin-bottom: 15px;">
      <!-- start of Premium Chart -->
      <h4 style="width: 100%; text-align: right; color: white; padding: 10px; text-shadow: 1px 0px 0px #fff;">
        تنظیمات تفسیر سلامتی
      </h4>
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapsetl1health"
                  aria-expanded="true" aria-controls="collapsetl1health">
           تفسیر سیارات در ناکشاترا
          </button>
        </h2>
        <div id="collapsetl1health" class="accordion-collapse collapse hide" data-bs-parent="#accordionExamplehealth">
          <div class="accordion-body">


            <div  class="row mt-4">
              <div class="container w-100 p-3 bg-light rounded">
                <div class="col-12 p-3" style="text-align: center; font-size: 16px">


                  <div class="w-100 bg-light p-3 mb-4">
                    <h4 class="w-100 mt-4 mb-2" style="text-align: left">
                      {{ CONDITION_TITLE }}
                    </h4>
                    <div class="input-group mb-3" style="direction: ltr">
                      <span class="input-group-text">IF PLANET</span>
                      <select v-model="planet_NinePlanet" class="col-2" style="text-align: center">
                        <option value="Su">Su</option>
                        <option value="Mo">Mo</option>
                        <option value="Ma">Ma</option>
                        <option value="Me">Me</option>
                        <option value="Ju">Ju</option>
                        <option value="Ve">Ve</option>
                        <option value="Sa">Sa</option>
                        <option value="Ra">Ra</option>
                        <option value="Ke">Ke</option>
                      </select>
                      <span class="input-group-text">IN NAKASHATRA</span>
                      <select v-model="selected_planet_nak_no_nine_planet" class="form-control col-4">
                        <option value="1">1 - Ashwini</option>
                        <option value="2">2 - Bharani</option>
                        <option value="3">3 - Krittika</option>
                        <option value="4">4 - Rohini</option>
                        <option value="5">5 - Mrigashirsha</option>
                        <option value="6">6 - Ardra</option>
                        <option value="7">7 - Punarvasu</option>
                        <option value="8">8 - Pushya</option>
                        <option value="9">9 - Ashlesha</option>
                        <option value="10">10 - Magha</option>
                        <option value="11">11 - Purva Phalguni</option>
                        <option value="12">12 - Uttara Phalguni</option>
                        <option value="13">13 - Hasta</option>
                        <option value="14">14 - Chitra</option>
                        <option value="15">15 - Swati</option>
                        <option value="16">16 - Vishakha</option>
                        <option value="17">17 - Anuradha</option>
                        <option value="18">18 - Jyeshtha</option>
                        <option value="19">19 - Mula</option>
                        <option value="20">20 - Purva Ashadha</option>
                        <option value="21">21 - Uttara Ashadha</option>
                        <option value="22">22 - Shravana</option>
                        <option value="23">23 - Dhanishta</option>
                        <option value="24">24 - Shatabhisha</option>
                        <option value="25">25 - Purva Bhadrapada</option>
                        <option value="26">26 - Uttara Bhadrapada</option>
                        <option value="27">27 - Revati</option>
                      </select>

                      <button id="button-addon2" class="btn btn-primary" type="button" @click="loadConditionhealthNinePlanet">
                        Load
                      </button>
                      <button id="button-addon2" class="btn btn-success" type="button" @click="saveConditionhealthNinePlanet">
                        {{ saveOrUpdate }}
                      </button>
                    </div>

                    <div class="mb-3 talent_titles">

                      <div class="d-flex flex-column gap-3 align-items-start w-100">
                        <label for="health_title3">عنوان</label>
                        <input placeholder="عنوان " class="w-100" type="text" name="health_title3" id="health_title3" v-model="health_title3">
                      </div>

                      <div class="d-flex flex-column gap-3 align-items-start w-100">
                        <label for="hora_order">عدد اولویت (اوردر)</label>
                        <select class="w-100" name="hora_order" id="hora_order" v-model="hora_order">
                          <option v-for="number in 9" :key="number" :value="number">{{ number }}</option>
                        </select>
                      </div>
                      <div>
                        <input type="checkbox"
                               id="talent_inactive"
                               v-model="talentInactive_ninePlanet"
                               :value="talentInactive_ninePlanet"
                               :checked="talentInactive_ninePlanet"
                        >
                        <label for="talent_inactive">غیر فعال کردن</label>
                      </div>
                    </div>
                    <div class="w-100">
                      <p class="text-end font-weight-bold">توضیحات</p>
                      <editor v-model="editorData3" :init="tinyMceInit"/>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#healthPreVoices" aria-expanded="false" aria-controls="healthPreVoices">
           ویس قبل خرید
          </button>
        </h2>
        <div id="healthPreVoices" class="accordion-collapse collapse" data-bs-parent="#accordionExamplehealth">
          <div class="accordion-body">
            <form @submit.prevent="saveSettings_health_voices">
              <!-- Loop to display voice inputs first -->
              <div v-for="(value, key) in healthVoiceTextData" :key="key" class="form-group">
                <label :for="key + '_voice'">{{ key }} Voice mp3 URL</label>
                <input
                    type="text"
                    class="form-control mb-3"
                    :id="key + '_voice'"
                    v-model="healthVoiceTextData[key].voice"
                >
              </div>

              <!-- Loop to display text inputs next -->
              <div v-for="(value, key) in healthVoiceTextData" :key="key + '_text'" class="form-group">
                <p style="font-size: 20px" class="mb-2 mt-2">{{ key }} Text 👇</p>
                <editor v-model="healthVoiceTextData[key].text" :init="tinyMceInit"/>
              </div>

              <button type="submit" class="btn btn-primary">ذخیره اطلاعات</button>
            </form>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#healthAsenTexts" aria-expanded="false" aria-controls="healthAsenTexts">
           تکست اسندانت اول و آخر
          </button>
        </h2>
        <div id="healthAsenTexts" class="accordion-collapse collapse" data-bs-parent="#accordionExamplehealth">
          <div class="accordion-body">
            <div class="container w-100 p-3 bg-light rounded">
              <!-- <p>Load configuration of risgins and their planets conditions</p> -->
              <div class="input-group" style="direction: ltr">
                <select v-model="selected_sign_texts" class="form-control w-100">
                  <option value="1">Aries - 1</option>
                  <option value="2">Taurus - 2</option>
                  <option value="3">Gemini - 3</option>
                  <option value="4">Cancer - 4</option>
                  <option value="5">Leo - 5</option>
                  <option value="6">Virgo - 6</option>
                  <option value="7">Libra - 7</option>
                  <option value="8">Scorpio - 8</option>
                  <option value="9">Saggitarius - 9</option>
                  <option value="10">Capricorn - 10</option>
                  <option value="11">Aquarius - 11</option>
                  <option value="12">Pisces - 12</option>
                </select>
                <button type="button" class="btn btn-outline-primary" @click="loadSignAsenText">
                  Load configuration
                </button>
                <button id="button-addon2" class="btn btn-success" type="button" @click="saveSignTextshealth">
                  {{ saveOrUpdate }}
                </button>
              </div>
            </div>

            <div  class="mb-3 talent_titles">
              <div class="d-flex flex-column gap-3 align-items-start w-100">
                <label for="health_title3"> عنوان اول</label>
                <input placeholder="عنوان " class="w-100" type="text" name="health_title3" id="health_title3" v-model="sign_texts_title_1">
              </div>

              <editor v-model="sign_texts_editor_1" :init="tinyMceInit"/>

              <div class="d-flex flex-column gap-3 align-items-start w-100">
                <label for="health_title3"> عنوان دوم</label>
                <input placeholder="عنوان " class="w-100" type="text" name="health_title3" id="health_title3" v-model="sign_texts_title_2">
              </div>
              <editor v-model="sign_texts_editor_2" :init="tinyMceInit"/>
            </div>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#AsenPelanethealthData" aria-expanded="false" aria-controls="AsenPelanethealthData">
            تفسیر خانه ای (سلامتی)
          </button>
        </h2>
        <div id="AsenPelanethealthData" class="accordion-collapse collapse" data-bs-parent="#accordionExamplehealth">
          <div class="accordion-body">
            <div class="container w-100 p-3 bg-light rounded">
              <!-- <p>Load configuration of risgins and their planets conditions</p> -->
              <div class="input-group" style="direction: ltr">
                <select v-model="selected_sign" class="form-control w-100">
                  <option value="1">Aries - 1</option>
                  <option value="2">Taurus - 2</option>
                  <option value="3">Gemini - 3</option>
                  <option value="4">Cancer - 4</option>
                  <option value="5">Leo - 5</option>
                  <option value="6">Virgo - 6</option>
                  <option value="7">Libra - 7</option>
                  <option value="8">Scorpio - 8</option>
                  <option value="9">Saggitarius - 9</option>
                  <option value="10">Capricorn - 10</option>
                  <option value="11">Aquarius - 11</option>
                  <option value="12">Pisces - 12</option>
                </select>
                <button type="button" class="btn btn-outline-primary" @click="loadSignhealth">
                  Load configuration
                </button>
              </div>
            </div>

            <div v-if="sign_no" class="row mt-4">
              <div class="container w-100 p-3 bg-light rounded">
                <div class="col-12">
                  <div class="w-100 p-3 bg-light rounded mb-3">
                    <h4 style="width: 100%; text-align: center">
                      <b> Sign: {{ selected_sign_screen }} </b>
                    </h4>
                  </div>
                  <div class="w-100 p-3 bg-light rounded">

                  </div>
                </div>
              </div>
            </div>

            <div v-if="sign_no" class="row mt-4">
              <div class="container w-100 p-3 bg-light rounded">
                <div class="col-12 p-3" style="text-align: center; font-size: 16px">
                  <div class="w-100 bg-light p-3 mb-4">
                    <h4 class="w-100 mt-4 mb-2" style="text-align: left">
                      {{ CONDITION_TITLE }}
                    </h4>

                    <div class="input-group mb-3" style="direction: ltr">
                      <span class="input-group-text">IF PLANET</span>
                      <select v-model="planet" class="col-2" style="text-align: center">
                        <option value="Su">Su</option>
                        <option value="Mo">Mo</option>
                        <option value="Ma">Ma</option>
                        <option value="Me">Me</option>
                        <option value="Ju">Ju</option>
                        <option value="Ve">Ve</option>
                        <option value="Sa">Sa</option>
                        <option value="Ra">Ra</option>
                        <option value="Ke">Ke</option>
                      </select>
                      <span class="input-group-text">IS IN HOUSE NUMBER</span>
                      <select v-model="house" class="col-2" style="text-align: center">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                      </select>
                      <button id="button-addon2" class="btn btn-primary" type="button" @click="loadSignConditionhealth">
                        Load
                      </button>
                      <button id="button-addon2" class="btn btn-success" type="button" @click="saveConditionhealth">
                        {{ saveOrUpdate }}
                      </button>
                    </div>

                    <div class="d-flex w-100 mb-3">
                      <input type="checkbox"
                             id="talent_inactive"
                             v-model="talentInactive"
                             :value="talentInactive"
                             :checked="talentInactive"
                      >
                      <label for="talent_inactive">غیر فعال کردن</label>
                    </div>

                    <div class="d-flex flex-column gap-3 align-items-start w-100 mb-3">
                      <label for="hora_order_asendant">عدد اولویت (اوردر)</label>
                      <select class="w-100" name="hora_order_asendant" id="hora_order_asendant" v-model="hora_order_asendant">
                        <option v-for="number in 9" :key="number" :value="number">{{ number }}</option>
                      </select>
                    </div>

                    <div class="d-flex flex-column gap-3 align-items-start w-100 mb-3">
                      <label for="health_title4"> عنوان </label>
                      <input placeholder="عنوان " class="w-100" type="text" name="health_title4" id="health_title4" v-model="health_title4">
                    </div>

                    <editor v-model="editorData4" :init="tinyMceInit"/>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



















      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#NakTranzitData" aria-expanded="false" aria-controls="NakTranzitData">
           تفسیر ترانزیت ناکشاترایی
          </button>
        </h2>
        <div id="NakTranzitData" class="accordion-collapse collapse" data-bs-parent="#accordionExamplehealth">
          <div class="accordion-body">
            <div class="container w-100 p-3 bg-light rounded">
              <!-- <p>Load configuration of risgins and their planets conditions</p> -->
              <div class="input-group" style="direction: ltr">
                <select v-model="selected_sign_nakTranzit" class="form-control w-100">
                  <option value="1">Aries - 1</option>
                  <option value="2">Taurus - 2</option>
                  <option value="3">Gemini - 3</option>
                  <option value="4">Cancer - 4</option>
                  <option value="5">Leo - 5</option>
                  <option value="6">Virgo - 6</option>
                  <option value="7">Libra - 7</option>
                  <option value="8">Scorpio - 8</option>
                  <option value="9">Saggitarius - 9</option>
                  <option value="10">Capricorn - 10</option>
                  <option value="11">Aquarius - 11</option>
                  <option value="12">Pisces - 12</option>
                </select>
                <button type="button" class="btn btn-outline-primary" @click="loadTranzitNak">
                  Load configuration
                </button>
              </div>
            </div>

            <div v-if="sign_no_nakTranzit" class="row mt-4">
              <div class="container w-100 p-3 bg-light rounded">
                <div class="col-12">
                  <div class="w-100 p-3 bg-light rounded mb-3">
                    <h4 style="width: 100%; text-align: center">
                      <b> Sign: {{ selected_sign_screen_nakTranzit }} </b>
                    </h4>
                  </div>
                  <div class="w-100 p-3 bg-light rounded">

                  </div>
                </div>
              </div>
            </div>





            <div v-if="sign_no_nakTranzit" class="row mt-4">
              <div class="container w-100 p-3 bg-light rounded">
                <div class="col-12 p-3" style="text-align: center; font-size: 16px">


                  <div class="w-100 bg-light p-3 mb-4">
                    <h4 class="w-100 mt-4 mb-2" style="text-align: left">
                      {{ CONDITION_TITLE }}
                    </h4>
                    <div class="input-group mb-3" style="direction: ltr">
                      <span class="input-group-text">IF PLANET</span>
                      <select v-model="planet_NinePlanet_nakTranzit" class="col-2" style="text-align: center">
                        <option value="Su">Su</option>
                        <option value="Mo">Mo</option>
                        <option value="Ma">Ma</option>
                        <option value="Me">Me</option>
                        <option value="Ju">Ju</option>
                        <option value="Ve">Ve</option>
                        <option value="Sa">Sa</option>
                        <option value="Ra">Ra</option>
                        <option value="Ke">Ke</option>
                      </select>
                      <span class="input-group-text">IN NAKASHATRA</span>
                      <select v-model="selected_planet_nak_no_nine_planet_nakTranzit" class="form-control col-4">
                        <option value="1">1 - Ashwini</option>
                        <option value="2">2 - Bharani</option>
                        <option value="3">3 - Krittika</option>
                        <option value="4">4 - Rohini</option>
                        <option value="5">5 - Mrigashirsha</option>
                        <option value="6">6 - Ardra</option>
                        <option value="7">7 - Punarvasu</option>
                        <option value="8">8 - Pushya</option>
                        <option value="9">9 - Ashlesha</option>
                        <option value="10">10 - Magha</option>
                        <option value="11">11 - Purva Phalguni</option>
                        <option value="12">12 - Uttara Phalguni</option>
                        <option value="13">13 - Hasta</option>
                        <option value="14">14 - Chitra</option>
                        <option value="15">15 - Swati</option>
                        <option value="16">16 - Vishakha</option>
                        <option value="17">17 - Anuradha</option>
                        <option value="18">18 - Jyeshtha</option>
                        <option value="19">19 - Mula</option>
                        <option value="20">20 - Purva Ashadha</option>
                        <option value="21">21 - Uttara Ashadha</option>
                        <option value="22">22 - Shravana</option>
                        <option value="23">23 - Dhanishta</option>
                        <option value="24">24 - Shatabhisha</option>
                        <option value="25">25 - Purva Bhadrapada</option>
                        <option value="26">26 - Uttara Bhadrapada</option>
                        <option value="27">27 - Revati</option>
                      </select>

                      <button id="button-addon2" class="btn btn-primary" type="button" @click="loadTranzitConditionNak">
                        Load
                      </button>
                      <button id="button-addon2" class="btn btn-success" type="button" @click="saveTranzitConditionNak">
                        {{ saveOrUpdate }}
                      </button>
                    </div>

                    <div class="mb-3 talent_titles">

                      <div class="d-flex flex-column gap-3 align-items-start w-100">
                        <label for="health_title3">عنوان</label>
                        <input placeholder="عنوان " class="w-100" type="text" name="health_title3" id="health_title3" v-model="health_title3_nakTranzit">
                      </div>

                      <div class="w-100 d-flex flex-column gap-3 justify-content-end" v-if="selected_planet_nak_no_nine_planet_nakTranzit == 1 && sign_no_nakTranzit == 1">
                      <div class="d-flex flex-column gap-3 align-items-start w-100">
                        <label for="hora_order">عدد اولویت (اوردر)</label>
                        <select class="w-100" name="hora_order" id="hora_order" v-model="hora_order_nakTranzit">
                          <option v-for="number in 18" :key="number" :value="number">{{ number }}</option>
                        </select>
                      </div>
                      <div style="width: 112px;">
                        <input type="checkbox"
                               id="talent_inactive"
                               v-model="talentInactive_nakTranzit"
                               :value="talentInactive_nakTranzit"
                               :checked="talentInactive_nakTranzit"
                        >
                        <label for="talent_inactive">غیر فعال کردن</label>
                      </div>
                      </div>

                    </div>
                    <div class="w-100">
                      <p class="text-end font-weight-bold">توضیحات</p>
                      <editor v-model="editorData3_nakTranzit" :init="tinyMceInit"/>
                    </div>
                  </div>


                </div>
              </div>
            </div>



          </div>
        </div>
      </div>













      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#SignTranzitData_health" aria-expanded="false" aria-controls="SignTranzitData_health">
           تفسیر ترانزیت برجی
          </button>
        </h2>
        <div id="SignTranzitData_health" class="accordion-collapse collapse" data-bs-parent="#accordionExamplehealth">




          <div class="accordion-body">
            <div class="container w-100 p-3 bg-light rounded">
              <!-- <p>Load configuration of SignTranzitco risgins and their planets conditions</p> -->
              <div class="input-group" style="direction: ltr">
                <select v-model="SignTranzit_selected_sign" class="form-control w-100">
                  <option value="1">Aries - 1</option>
                  <option value="2">Taurus - 2</option>
                  <option value="3">Gemini - 3</option>
                  <option value="4">Cancer - 4</option>
                  <option value="5">Leo - 5</option>
                  <option value="6">Virgo - 6</option>
                  <option value="7">Libra - 7</option>
                  <option value="8">Scorpio - 8</option>
                  <option value="9">Saggitarius - 9</option>
                  <option value="10">Capricorn - 10</option>
                  <option value="11">Aquarius - 11</option>
                  <option value="12">Pisces - 12</option>
                </select>
                <button type="button" class="btn btn-outline-primary" @click="SignTranzitLoadSign">
                  Load configuration
                </button>
              </div>
            </div>

            <div v-if="SignTranzit_sign" class="row mt-4">
              <div class="container w-100 p-3 bg-light rounded">
                <div class="col-12">
                  <div class="w-100 p-3 bg-light rounded mb-3">
                    <h4 style="width: 100%; text-align: center">
                      <b> Sign: {{ SignTranzit_selected_sign_screen }} </b>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="SignTranzit_sign" class="row mt-4">
              <div class="container w-100 p-3 bg-light rounded">
                <div class="col-12 p-3" style="text-align: center; font-size: 16px">
                  <div class="w-100 bg-light p-3 mb-4">
                    <h4 class="w-100 mt-4 mb-2" style="text-align: left">
                      {{ SignTranzit_CONDITION_TITLE }}
                    </h4>

                    <div class="input-group mb-3" style="direction: ltr">
                      <span class="input-group-text">IF PLANET</span>
                      <select v-model="SignTranzit_planet" class="col-2" style="text-align: center">
                        <option value="Su">Su</option>
                        <option value="Mo">Mo</option>
                        <option value="Ma">Ma</option>
                        <option value="Me">Me</option>
                        <option value="Ju">Ju</option>
                        <option value="Ve">Ve</option>
                        <option value="Sa">Sa</option>
                        <option value="Ra">Ra</option>
                        <option value="Ke">Ke</option>
                      </select>
                      <span class="input-group-text">IS IN SIGN NUMBER</span>
                      <select v-model="SignTranzit_sign_no" class="col-2" style="text-align: center">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                      </select>
                      <button id="button-addon2" class="btn btn-primary" type="button" @click="loadTranzitConditionSign">
                        Load
                      </button>
                      <button id="button-addon2" class="btn btn-success" type="button" @click="saveTranzitConditionSign">
                        {{ SignTranzitSaveOrUpdate }}
                      </button>
                    </div>

                    <div class="mb-3 talent_titles">

                      <div class="d-flex flex-column gap-3 align-items-start w-100">
                        <label for="SignTranzit_title_1">عنوان</label>
                        <input placeholder="عنوان " class="w-100" type="text" name="SignTranzit_title_1" id="SignTranzit_title_1" v-model="SignTranzit_title_1">
                      </div>

                      <div class="w-100 d-flex flex-column gap-3 justify-content-end" v-if="SignTranzit_sign_no == 1 && SignTranzit_sign == 1">

                      <div class="d-flex flex-column gap-3 align-items-start w-100">
                        <label for="hora_order_SignTranzit">عدد اولویت (اوردر)</label>
                        <select class="w-100" name="hora_order_SignTranzit" id="hora_order_SignTranzit" v-model="hora_order_SignTranzit">
                          <option v-for="number in 18" :key="number" :value="number">{{ number }}</option>
                        </select>
                      </div>
                      <div style="width: 112px">
                        <input type="checkbox"
                               id="talent_inactive"
                               v-model="talentInactive_SignTranzit"
                               :value="talentInactive_SignTranzit"
                               :checked="talentInactive_SignTranzit"
                        >
                        <label for="talent_inactive">غیر فعال کردن</label>
                      </div>
                      </div>

                    </div>
                    <div class="w-100">
                      <p class="text-end font-weight-bold">توضیحات</p>
                      <editor v-model="SignTranzit_body_1" :init="tinyMceInit"/>
                    </div>

                    <br><br>
                    <div v-if="isSpecialPlanet" class="sign_r_class">
                    <div class=" pb-3 d-flex flex-column gap-3 align-items-start w-100">
                      <label for="SignTranzit_title_2">عنوان ۲</label>
                      <input placeholder="عنوان " class="w-100" type="text" name="SignTranzit_title_2" id="SignTranzit_title_2" v-model="SignTranzit_title_2">
                    </div>

                    <div class="w-100">
                      <p class="text-end font-weight-bold">توضیحات ۲</p>
                      <editor v-model="SignTranzit_body_2" :init="tinyMceInit"/>
                    </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>


<script>
import AdminService from "../../admin-service";

import 'tinymce/tinymce'
import 'tinymce/icons/default/icons'
import 'tinymce/themes/silver/theme'
import 'tinymce/models/dom/model'
import 'tinymce/skins/ui/oxide/skin.css'
import 'tinymce/plugins/lists/plugin'
import 'tinymce/plugins/link/plugin'
import 'tinymce/plugins/image/plugin'
import 'tinymce/plugins/media/plugin'
import 'tinymce/plugins/table/plugin'
import 'tinymce/plugins/code/plugin'
import 'tinymce/plugins/help/plugin'
import 'tinymce/plugins/wordcount/plugin'
import Editor from '@tinymce/tinymce-vue'


export default {
  name: 'HealthAdmin',
  components: {
    Editor,
  },
  props: {
    tinyMceInit: Object,
  },
  data() {
    return {
      CONDITION_TITLE: 'New Condition',
      saveOrUpdate: 'Save',


      SignTranzit_CONDITION_TITLE: 'Condition',
      SignTranzitSaveOrUpdate: 'Save',
      SignTranzit_sign_no: '',
      SignTranzit_planet: '',
      hora_order_SignTranzit: '',
      talentInactive_SignTranzit: '',
      SignTranzit_sign: '',
      SignTranzit_selected_sign: '',
      SignTranzit_selected_sign_screen: '',
      SignTranzit_condition_id: '',
      SignTranzit_conditions: [],
      SignTranzit_body_1: '',
      SignTranzit_body_2: '',
      SignTranzit_title_2: '',
      SignTranzit_title_1: '',

      // for nak tranzit
      sign_no_nakTranzit: '',
      selected_sign_nakTranzit: '',
      selected_sign_screen_nakTranzit: '',
      selected_planet_nak_no_nine_planet_nakTranzit: '',
      planet_NinePlanet_nakTranzit: '',
      hora_order_nakTranzit: '',
      talentInactive_nakTranzit: '',
      editorData3_nakTranzit: '',
      health_title3_nakTranzit: '',


      editorData2: '',
      editorData3: '',
      editorData4: '',
      health_title3: '',
      health_title4: '',
      talentInactive_ninePlanet: '',
      talentInactive: '',
      planet_NinePlanet: '',
      selected_planet_nak_no_nine_planet: '',
      hora_order: '',
      hora_order_asendant: '',
      selected_sign_texts: null,
      planet_signno_texts : '',
      sign_texts_editor_1 : '',
      sign_texts_editor_2 : '',
      sign_texts_title_1 : '',
      sign_texts_title_2 : '',
      sign_no : '',
      selected_sign : '',
      selected_sign_screen : '',
      healthVoiceTextData: {
        Aries: { voice: '', text: '' },
        Taurus: { voice: '', text: '' },
        Gemini: { voice: '', text: '' },
        Cancer: { voice: '', text: '' },
        Leo: { voice: '', text: '' },
        Virgo: { voice: '', text: '' },
        Libra: { voice: '', text: '' },
        Scorpio: { voice: '', text: '' },
        Saggitarius: { voice: '', text: '' },
        Capricorn: { voice: '', text: '' },
        Aquarius: { voice: '', text: '' },
        Pisces: { voice: '', text: '' }
      }
    }
  },


  computed: {
    isSpecialPlanet() {
      const specialPlanets = ['Ma', 'Me', 'Ve', 'Ju', 'Sa'];
      return specialPlanets.includes(this.SignTranzit_planet);
    }
  },


  watch: {
    SignTranzit_planet(newVal) {
      const specialPlanets = ['Ma', 'Me', 'Ve', 'Ju', 'Sa'];
      if (!specialPlanets.includes(newVal)) {
        this.title2 = '';
        this.detail_body2 = '';
      }
    }
  },
  mounted: function() {
    this.loadSettings_health_voices();
  },
  methods: {

    // START OF TRANZIT CODES

    loadTranzitNak() {
      AdminService.loadSignDetail(this.selected_sign_nakTranzit).then((response) => {
        this.sign_no_nakTranzit = response['data']['sign_no']
        this.selected_sign_nakTranzit = response['data']['sign_no']
        this.selected_sign_screen_nakTranzit = response['data']['sign_screen']
      })
    },

    saveTranzitConditionNak() {
      const request = {
        nak_no: this.selected_planet_nak_no_nine_planet_nakTranzit,
        planet: this.planet_NinePlanet_nakTranzit,
        hora_order: this.hora_order_nakTranzit,
        healthInactive: this.talentInactive_nakTranzit,
        detail_body: this.editorData3_nakTranzit,
        title: this.health_title3_nakTranzit,
        hora_analysis_id: this.sign_no_nakTranzit

      }
      AdminService.saveSignConditionhealthTranzitNak(request).then((response) => {
        alert('Updated!')
      })
    },

    loadTranzitConditionNak() {
      AdminService.loadSignConditionhealthTranzitNak(this.planet_NinePlanet_nakTranzit, this.selected_planet_nak_no_nine_planet_nakTranzit , this.sign_no_nakTranzit).then(
          (response) => {
            this.editorData3_nakTranzit = response['data']['detail_body'] ? response['data']['detail_body'] : "";
            this.planet_NinePlanet_nakTranzit = response['data']['planet'] ? response['data']['planet'] : this.planet_NinePlanet_nakTranzit;
            this.hora_order_nakTranzit = response['data']['hora_order'] ? response['data']['hora_order'] : '';
            this.talentInactive_nakTranzit = response['data']['inactive'] === "true";
            this.selected_planet_nak_no_nine_planet_nakTranzit = response['data']['nak_no'] ? response['data']['nak_no'] : this.selected_planet_nak_no_nine_planet_nakTranzit;
            this.health_title3_nakTranzit = response['data']['title'] ? response['data']['title'] : '';
            this.sign_no_nakTranzit = response['data']['hora_analysis_id']
                ? response['data']['hora_analysis_id']
                : this.sign_no_nakTranzit
          }
      )
    },

    // END OF TRANZIT CODES

    // START OF TRANZIT CODES - SIGN

    saveTranzitConditionSign() {
      const request = {
        sign_no: this.SignTranzit_sign_no,
        planet: this.SignTranzit_planet,
        hora_order: this.hora_order_SignTranzit,
        healthInactive: this.talentInactive_SignTranzit,
        SignTranzit_body_1: this.SignTranzit_body_1,
        SignTranzit_body_2: this.SignTranzit_body_2,
        SignTranzit_title_2: this.SignTranzit_title_2,
        SignTranzit_title_1: this.SignTranzit_title_1,
        hora_analysis_id: this.SignTranzit_sign
      }
      AdminService.saveSignConditionhealthTranzitSign(request).then((response) => {
        alert('Updated!')
      })
    },

    loadTranzitConditionSign() {
      AdminService.loadSignConditionhealthTranzitSign(this.SignTranzit_planet, this.SignTranzit_sign_no , this.SignTranzit_sign).then(
          (response) => {
            this.SignTranzit_body_1 = response['data']['detail_body1'] ? response['data']['detail_body1'] : "";
            this.SignTranzit_body_2 = response['data']['detail_body2'] ? response['data']['detail_body2'] : "";


            this.SignTranzit_planet = response['data']['planet'] ? response['data']['planet'] : this.SignTranzit_planet;
            this.hora_order_SignTranzit = response['data']['hora_order'] ? response['data']['hora_order'] : '';

            this.talentInactive_SignTranzit = response['data']['inactive'] === "true";
            this.SignTranzit_sign_no = response['data']['sign'] ? response['data']['sign'] : this.SignTranzit_sign_no;


            this.SignTranzit_title_1 = response['data']['title1'] ? response['data']['title1'] : '';
            this.SignTranzit_title_2 = response['data']['title2'] ? response['data']['title2'] : '';

            this.SignTranzit_sign = response['data']['hora_analysis_id']
                ? response['data']['hora_analysis_id']
                : this.SignTranzit_sign
          }
      )
    },

    // END OF TRANZIT CODES  - SIGN


    SignTranzitLoadSign() {
      AdminService.loadSignDetail(this.SignTranzit_selected_sign).then((response) => {

        this.SignTranzit_sign = response['data']['sign_no']
        this.SignTranzit_conditions = response['data']['conditions']
        this.SignTranzit_selected_sign = response['data']['sign_no']
        this.SignTranzit_selected_sign_screen = response['data']['sign_screen']
        this.SignTranzitEditor = response['data']['sign_desc']
            ? response['data']['sign_desc']
            : ''
      })
    },

    loadSettings_health_voices: function() {


      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          action: 'get_health_voices',
        })
      })
          .then(response => response.json())
          .then(data => {
            if (data.success) {
              console.log("Tl Voice", data);
              Object.keys(data.data).forEach(key => {
                this.healthVoiceTextData[key] = {
                  voice: data.data[key].voice || '',
                  text: data.data[key].text || ''
                };
              });
            } else {
              console.error('اطلاعات دریافت نشد!!!!!!!');
            }
          });
    },

    saveSettings_health_voices: function() {
      const data = {
        action: 'save_health_voices',
        health_voices: JSON.stringify(this.healthVoiceTextData)
      };

      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(data)
      })
          .then(response => response.json())
          .then(data => {
            if (data.success) {
              alert('تنظیمات با موفقیت ذخیره شد');
            } else {
              alert('اطلاعات ذخیره نشد !!');
            }
          });
    },

    loadSignConditionhealth() {
      AdminService.loadSignConditionhealth(this.sign_no, this.planet, this.house).then(
          (response) => {
            this.health_title4 = response['data']['title']
            this.hora_order_asendant = response['data']['hora_order']
            this.editorData4 = response['data']['detail_body']
                ? response['data']['detail_body']
                : ''
            this.planet = response['data']['planet']
                ? response['data']['planet']
                : this.planet

            this.house = response['data']['house']
                ? response['data']['house']
                : this.house

            this.sign_no = response['data']['hora_analysis_id']
                ? response['data']['hora_analysis_id']
                : this.sign_no

            this.talentInactive = response['data']['inactive'] === "true"
          }
      )
    },

    saveConditionhealth() {
      const request = {
        title: this.health_title4,
        planet: this.planet,
        house: this.house,
        healthInactive: this.talentInactive,
        hora_order: this.hora_order_asendant,
        detail_body: this.editorData4,
        hora_analysis_id: this.sign_no,
      }
      AdminService.saveSignConditionhealth2(request).then((response) => {
        alert('Updated!')
      })
    },

    loadSignhealth() {
      AdminService.loadSignDetail(this.selected_sign).then((response) => {
        this.sign_no = response['data']['sign_no']
        this.selected_sign = response['data']['sign_no']
        this.selected_sign_screen = response['data']['sign_screen']
      })
    },

    loadSignAsenText() {
      AdminService.loadSignDetailhealthTexts(this.selected_sign_texts).then((response) => {
        this.selected_sign_texts = response['data']['sign_no'] ? response['data']['sign_no'] : this.selected_sign_texts
        this.sign_texts_editor_2 = response['data']['body2']
            ? response['data']['body2']
            : ''
        this.sign_texts_editor_1 = response['data']['body1']
            ? response['data']['body1']
            : ''
        this.sign_texts_title_1 = response['data']['title1']
        this.sign_texts_title_2 = response['data']['title2']
      })
    },

    saveSignTextshealth() {
      const request = {
        sign_no: this.selected_sign_texts,
        body2: this.sign_texts_editor_2,
        body1: this.sign_texts_editor_1,
        title1: this.sign_texts_title_1,
        title2: this.sign_texts_title_2,
      }
      AdminService.saveSignTextshealth(request).then((response) => {
        alert('Updated!')
      })
    },

    saveConditionhealthNinePlanet() {
      const request = {
        nak_no: this.selected_planet_nak_no_nine_planet,
        planet: this.planet_NinePlanet,
        hora_order: this.hora_order,
        healthInactive: this.talentInactive_ninePlanet,
        detail_body: this.editorData3,
        title: this.health_title3
      }
      AdminService.saveSignConditionhealth(request).then((response) => {
        alert('Updated!')
      })
    },

    loadConditionhealthNinePlanet() {
      AdminService.loadSignConditionhealthNinePlanet(this.planet_NinePlanet, this.selected_planet_nak_no_nine_planet).then(
          (response) => {
            this.editorData3 = response['data']['body'] ? response['data']['body'] : "";
            this.planet_NinePlanet = response['data']['planet'] ? response['data']['planet'] : this.planet_NinePlanet;
            this.hora_order = response['data']['hora_order'] ? response['data']['hora_order'] : this.hora_order;
            this.talentInactive_ninePlanet = response['data']['inactive'] === "true" ? response['data']['inactive'] === "true" : this.talentInactive_ninePlanet;
            this.selected_planet_nak_no_nine_planet = response['data']['nak_no'] ? response['data']['nak_no'] : this.selected_planet_nak_no_nine_planet;
            this.health_title3 = response['data']['title'] ? response['data']['title'] : '';
          }
      )
    },
  },
};
</script>


<style>
.sign_r_class {
  border: 6px solid #bb5abd;
  border-radius: 14px;
  padding: 14px;
}
</style>